export default "__VITE_ASSET__VOXBqBbe__"